import { useQuery } from "@tanstack/vue-query";
import { api } from "../api";
import { keys, type ResponseType } from "../api.keys";
import type { ReferralRewards } from "../types";
import { useWalletsStore } from "~/stores/wallets";

export async function getReferralRewards(wallet: string) {
  const { data } = await api.get<ResponseType<ReferralRewards>>(
    "/referral/rewards",
    {
      params: {
        wallet,
      },
    }
  );

  return data;
}

export function useReferralRewards() {
  const wallet = useWalletsStore();
  const address = computed(() => wallet.wallet?.publicKey?.toBase58?.() || "");

  return useQuery({
    queryKey: keys.referralRewards(unref(address)),
    queryFn: () => getReferralRewards(unref(address)),
    enabled: !!wallet.wallet && unref(address) !== "",
  });
}
